import { render, staticRenderFns } from "./CardResumoCompras.vue?vue&type=template&id=b037c42c&"
import script from "./CardResumoCompras.vue?vue&type=script&lang=js&"
export * from "./CardResumoCompras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports